const footerList = [
  {
    title: 'İDDAA OYNA',
    list: [
      {
        content: 'İddaa',
        path: '/iddaa'
      },
      {
        content: 'Basketbol',
        path: '/iddaa/basketbol'
      },
      {
        content: 'Tenis',
        path: '/iddaa/tenis'
      },
      {
        content: 'E-Futbol',
        path: '/iddaa/e-futbol'
      },
      {
        content: 'E-Basketbol',
        path: '/iddaa/e-basketbol'
      },
      {
        content: 'Amerikan Futbolu',
        path: '/iddaa/amerikan-futbol'
      },
      {
        content: 'Düello',
        path: '/iddaa/duello'
      },
      {
        content: 'Masa Tenisi',
        path: '/iddaa/masa-tenisi'
      },
      {
        content: 'Buz Hokeyi',
        path: '/iddaa/buz-hokeyi'
      },
      {
        content: 'MMA',
        path: '/iddaa/mma'
      },
      {
        content: 'Voleybol',
        path: '/iddaa/voleybol'
      },
      {
        content: 'Hentbol',
        path: '/iddaa/hentbol'
      },
      {
        content: 'Snooker',
        path: '/iddaa/snooker'
      }
    ]
  },
  {
    title: 'CANLI İDDAA',
    list: [
      {
        content: 'Canlı İddaa',
        path: '/canli-iddaa'
      },
      {
        content: 'Futbol',
        path: '/canli-iddaa/futbol'
      },
      {
        content: 'Basketbol',
        path: '/canli-iddaa/basketbol'
      },
      {
        content: 'Masa Tenisi',
        path: '/canli-iddaa/masa-tenisi'
      },
      {
        content: 'Buz Hokeyi',
        path: '/canli-iddaa/buz-hokeyi'
      },
      {
        content: 'Tenis',
        path: '/canli-iddaa/tenis'
      },
      {
        content: 'Voleybol',
        path: '/canli-iddaa/voleybol'
      },
      {
        content: 'Hentbol',
        path: '/canli-iddaa/hentbol'
      },
      {
        content: 'Snooker',
        path: '/canli-iddaa/snooker'
      }
    ]
  },
  {
    title: 'POPÜLER BAHİSLER',
    list: [
      {
        content: 'Futbol',
        path: '/iddaa/populer-bahisler'
      },
      {
        content: 'Basketbol',
        path: '/iddaa/populer-bahisler/basketbol'
      },
      {
        content: 'E-Spor',
        path: '/iddaa/populer-bahisler/e-spor'
      },
      {
        content: 'Tenis',
        path: '/iddaa/populer-bahisler/tenis'
      }
    ]
  },
  {
    title: 'CANLI MAÇ İZLE',
    list: [
      {
        content: 'Canlı Maç İzle',
        path: '/canli-mac-izle'
      },
      {
        content: 'Canlı Futbol Maçı İzle',
        path: '/canli-mac-izle/canli-futbol-izle'
      },
      {
        content: 'Canlı Basketbol İzle',
        path: '/canli-mac-izle/canli-basketbol-izle'
      },
      {
        content: 'Canlı Tenis İzle',
        path: '/canli-mac-izle/canli-tenis-izle'
      },
      {
        content: 'Canlı Masa Tenisi İzle',
        path: '/canli-mac-izle/canli-masa-tenisi-izle'
      },
      {
        content: 'Canlı Voleybol İzle',
        path: '/canli-mac-izle/canli-voleybol-izle'
      },
      {
        content: 'Canlı E-Futbol İzle',
        path: '/canli-mac-izle/canli-e-futbol-izle'
      },
      {
        content: 'Canlı E-Basketbol İzle',
        path: '/canli-mac-izle/canli-e-basketbol-izle'
      },
      {
        content: 'Canlı Buz Hokeyi İzle',
        path: '/canli-mac-izle/canli-buz-hokeyi-izle'
      }
    ]
  },
  {
    title: 'CANLI SKOR',
    list: [
      {
        content: 'Canlı Skor',
        path: '/canli-skor'
      },
      {
        content: 'Canlı Skor Basketbol',
        path: '/canli-skor/basketbol-canli-skor'
      }
    ]
  },
  {
    title: 'LİG MERKEZİ',
    path: '/lig-merkezi',
    className: 'league-resize',
    visibleKeyProps: 'league_center_toogle_on'
  },
  {
    title: 'YAZARLAR',
    path: '/yazarlar',
  },
  {
    title: 'SPOR TOTO',
    list: [
      {
        content: 'Spor Toto Oyna',
        path: '/spor-toto'
      },
      {
        content: 'Kuponlarım',
        path: '/spor-toto/kuponlarim',
        linkOptions: {
          rel: 'nofollow'
        }
      },
      {
        content: 'Spor Toto Sonuçları',
        path: '/spor-toto/sonuclar'
      }
    ]
  },
  {
    title: 'TRİBÜN',
    path: '/tribun',
  },
  {
    title: 'KAMPANYALAR',
    path: '/kampanyalar',
    linkOptions: {
      rel: 'nofollow'
    }
  },
  {
    title: 'AT YARIŞI',
    visibleKeyProps: 'tjk_main_page_visible_v2',
    badgeNew: true,
    list: [
      {
        content: 'At Yarışı Bülteni',
        path: '/tjk/at-yarisi-bulteni'
      },
      {
        content: 'Sabit İhtimalli Yarış Bülteni',
        path: '/tjk/sabit-ihtimalli-at-yarisi-bulteni',
      },
      {
        content: 'At Yarışı Tahminleri',
        path: '/tjk/at-yarisi-tahminleri'
      },
      {
        content: 'Muhtemeller',
        path: '/tjk/muhtemeller'
      },
      {
        content: 'At Yarışı Sonuçları',
        path: '/tjk/at-yarisi-sonuclari'
      },
      {
        content: 'Yaklaşan Koşular',
        path: '/tjk/yaklasan-kosular'
      },
      {
        content: 'Raporlu & Cezalı Jokeyler',
        path: '/tjk/raporlu-cezali-jokeyler?selectedTab=reported'
      },
      {
        content: 'TJK Canlı TV',
        path: '/tjk/tjk-tv-canli-izle',
      },
      {
        content: 'TJK TV Yurtdışı Canlı',
        path: '/tjk/tjk-tv-yurtdisi-izle',
      },
    ]
  },
  {
    title: 'SANAL BAHİS',
    list: [{
      content: 'Pro Lig Türkiye',
      path: '/sanal-bahis/pro-lig-serbest-vurus-turkiye'
    },
    {
      content: 'SVP Türkiye',
      path: '/sanal-bahis/serbest-vurus-pro-turkiye'
    },
    {
      content: 'Pro Lig İtalya',
      path: '/sanal-bahis/pro-lig-serbest-vurus-italya'
    },
    {
      content: 'SVP İtalya',
      path: '/sanal-bahis/serbest-vurus-pro-italya'
    },
    {
      content: 'Bilyoner Sanal Ligi',
      path: '/sanal-bahis/bilyoner-sanal-ligi'
    },
    {
      content: 'Tüm Oyunlar',
      path: '/sanal-bahis',
    }]
  },
  {
    title: 'KAZI KAZAN',
    badgeNew: true,
    list: [
      {
        content: 'Volkanik Harita',
        path: '/kazi-kazan/volkanik-harita',
      },
      {
        content: 'Piramitlerin Efsanesi',
        path: '/kazi-kazan/piramitlerin-efsanesi'
      },
      {
        content: "Parlayan 7'li",
        path: '/kazi-kazan/parlayan-7li',
      },
      {
        content: '50 Kat Şans',
        path: '/kazi-kazan/50-kat-sans',
      },
      {
        content: 'Buz Fırtınası',
        path: '/kazi-kazan/buz-firtinasi',
      },
      {
        content: 'İpek Yolu Sandığı',
        path: '/kazi-kazan/ipek-yolu-sandigi'
      },
      {
        content: 'Büyülü Kış',
        path: '/kazi-kazan/buyulu-kis',
      },
      {
        content: 'Tüm Oyunlar',
        path: '/kazi-kazan'
      },
    ]
  },
  {
    title: 'SAYISAL OYUNLAR',
    list: [
      {
        content: 'Hızlı On Numara',
        path: '/milli-piyango/hizli-on-numara'
      },
      {
        content: 'Çılgın Sayısal Loto',
        path: '/milli-piyango/sayisal-loto'
      },
      {
        content: 'Süper Loto',
        path: '/milli-piyango/super-loto'
      },
      {
        content: 'On Numara',
        path: '/milli-piyango/on-numara'
      },
      {
        content: 'Şans Topu', path: '/milli-piyango/sans-topu'
      },
      {
        content: 'Milli Piyango',
        path: '/milli-piyango/milli-piyango'
      },
      {
        content: 'Tüm Oyunlar',
        path: '/milli-piyango',
      }]
  },
  {
    title: 'ŞANS OYUNLARI',
    list: [
      {
        content: 'Menajer Lig',
        path: '/sans-oyunlari/menajer-lig',
      },
      {
        content: 'Süper Tombala',
        path: '/sans-oyunlari/super-tombala',
      },
      {
        content: 'Zeplin',
        path: '/sans-oyunlari/zeplin',
      },
      {
        content: 'Altın Çark',
        path: '/sans-oyunlari/altin-cark',
      },
      {
        content: 'Şanslı 6',
        path: '/sans-oyunlari/sansli-alti',
      },
      {
        content: 'Süper Çarkıfelek',
        path: '/sans-oyunlari/super-carkifelek',
      },
      {
        content: 'Şans Kuşu',
        path: '/sans-oyunlari/sans-kusu',
      },
      {
        content: 'Kazandıran Balonlar',
        path: '/sans-oyunlari/kazandiran-balonlar',
      },
      {
        content: 'Süper Onlu',
        path: '/sans-oyunlari/super-onlu',
      },
      {
        content: 'Tüm Oyunlar',
        path: '/sans-oyunlari',
      },
    ]
  },
  {
    title: 'SANAL YARIŞ',
    list: [
      {
        content: 'Gerçek Görüntülü At Yarışı',
        path: '/sanal-yaris/gercek-goruntulu-at-yarisi'
      },
      {
        content: 'Sanal At Yarışı',
        path: '/sanal-yaris/sanal-at-yarisi'
      },
      {
        content: 'Sanal Engel Atlama Yarışı',
        path: '/sanal-yaris/sanal-engel-atlama-yarisi'
      },
      {
        content: 'Sanal At Arabası Yarışı',
        path: '/sanal-yaris/sanal-at-arabasi-yarisi'
      },
      {
        content: 'Gerçek Görüntülü Tazı Yarışı',
        path: '/sanal-yaris/gercek-goruntulu-tazi-yarisi'
      },
      {
        content: 'Sanal Tazı Yarışı',
        path: '/sanal-yaris/sanal-tazi-yarisi'
      },
      {
        content: 'Tüm Oyunlar',
        path: '/sanal-yaris'
      },
    ],
    visibleKeyProps: 'main_page_virtual_horse_race_visible',
  },
  {
    title: 'BASKAZAN',
    list: [
      {
        content: 'Büyük Mücevher Avcısı',
        path: '/bas-kazan/buyuk-mucevher-avcisi'
      },
      {
        content: ' Harika Ganimet Avcısı',
        path: '/bas-kazan/harika-ganimet-avcisi'
      },
      {
        content: 'Şans Uçağı',
        path: '/bas-kazan/sans-ucagi'
      },
      {
        content: 'Ra’nın Gizemi',
        path: '/bas-kazan/ranin-gizemi'
      },
      {
        content: 'Tüm Oyunlar',
        path: '/bas-kazan'
      },
    ],
    visibleKeyProps: 'main_page_tap_win_visible',
  },
  {
    title: 'BİLYONER BLOG',
    visibleKeyProps: 'bilyoner_blog_footer_visible',
    path: '/',
    linkOptions: {
      rel: 'nofollow'
    }
  },
  {
    title: 'DUYURULAR',
    path: '/duyurular',
    linkOptions: {
      rel: 'nofollow'
    }
  },
  {
    title: 'İNDİR',
    path: '/indir',
  },
  {
    title: "BİLYONER'İN EN'LERİ",
    path: '/yilin-enleri',
  },
  {
    title: 'ÇEREZ AYARLARI',
    className: 'efl-edit',
    linkOptions: {
      rel: 'nofollow'
    }
  },
  {
    title: 'YARDIM',
    list: [],
  },
  {
    title: 'BİZE YAZIN',
    path: '/yardim/bize-yazin',
    linkOptions: {
      rel: 'nofollow'
    }
  },
  {
    title: 'HAKKIMIZDA',
    path: '/hakkimizda',
  },
  {
    title: 'SORUMLU OYUN',
    path: '/bilyoner/sorumlu-bahis',
  },
];

export default footerList;
